import {
  getCustomerDataByNik,
  updateProvinceTransactionRestriction,
} from '../../utils/api';
import { SEARCH_FAILED, SEARCH_LOADING, SEARCH_SUCCESS } from './constants';

export function setFailedAction({ key, data, message, error, code, status }) {
  return { type: SEARCH_FAILED, key, data, message, error, code, status };
}

export function setLoadingAction({ key, isLoading = true }) {
  return { type: SEARCH_LOADING, key, isLoading };
}

export function setSuccessAction({ key, data, code, message, success, status }) {
  return { type: SEARCH_SUCCESS, key, data, code, message, success, status };
}

export const clearRedux = (key) => {
  return async (dispatch) => {
    dispatch(setLoadingAction({ key, isLoading: false }));
    dispatch(setSuccessAction({ key, data: null, code: null, message: '', success: false, status: '' }));
    dispatch(setFailedAction({ key, message: '', error: null, code: null, status: '' }));
  };
};

export function fetchProvinceTransactionRestriction(
  nationalityId,
  isMasked = true,
  yearMonth
) {
  return async (dispatch) => {
    const key = 'dataProvinceTransactionRestriction';
    try {
      dispatch(setLoadingAction({ key, isLoading: true }));
      const { data, code, message, status } = await getCustomerDataByNik(
        nationalityId,
        isMasked,
        yearMonth
      );
      data.nationalityIdPlan = nationalityId;
      dispatch(setSuccessAction({ key, data, code, message, status }));
    } catch (error) {
      dispatch(setFailedAction({
        key,
        data: error.data,
        message: error?.message,
        code: error?.code || null,
        error,
        status: error?.status || '',
      }));
      dispatch(setLoadingAction({ key, isLoading: false }));
    }
  };
}

export function actionUpdateProvinceTransactionRestriction(payload, callback = () => {}) {
  return async (dispatch) => {
    const key = 'updateProvinceTransactionRestriction';
    try {
      dispatch(setLoadingAction({ key, isLoading: true }));
      const { data, code, message, status } = await updateProvinceTransactionRestriction(payload);
      dispatch(setSuccessAction({ key, data, code, message, status }));
      dispatch(setLoadingAction({ key, isLoading: false }));
      callback({ success: true, data, message, status, code });
    } catch (error) {
      const response = {
        data: error?.data,
        message: error?.message,
        code: error?.code || null,
        error,
        status: error?.status || '',
      };
      dispatch(setFailedAction({ key, ...response }));
      dispatch(setLoadingAction({ key, isLoading: false }));
      callback({ success: false, ...response });
    }
  };
}
